import { Link } from 'react-router'
import styled from 'styled-components'

export const CommonLink = styled(Link)`
  font-weight: bold;
`
